import type { HttpClient, RequestOptions } from '../client.js';
import type { HealthResponse } from '../types/index.js';

/** Utility and infrastructure methods */
export class UtilsNamespace {
  constructor(private readonly client: HttpClient) {}

  /**
   * Check API health status.
   */
  async health(options?: RequestOptions): Promise<HealthResponse> {
    return this.client.jsonRpc<HealthResponse>('getHealth', {}, { ...options, cacheTtl: 0 });
  }
}
